import { useEffect } from "react";
import type { ReactNode } from "react";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  width?: number | string;
  ariaLabel?: string;
}

// Stack of currently-open modals so Escape only closes the topmost one —
// otherwise a modal opened on top of another (e.g. a media preview inside the
// playlist editor) would close both with a single Escape press.
const openModals: object[] = [];

export function Modal({ open, onClose, children, width, ariaLabel }: ModalProps) {
  useEffect(() => {
    if (!open) return;
    const token = {};
    openModals.push(token);
    function onKey(e: KeyboardEvent) {
      if (e.key === "Escape" && openModals[openModals.length - 1] === token) {
        onClose();
      }
    }
    window.addEventListener("keydown", onKey);
    return () => {
      window.removeEventListener("keydown", onKey);
      const i = openModals.indexOf(token);
      if (i !== -1) openModals.splice(i, 1);
    };
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div
      className="modal-backdrop"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
      role="dialog"
      aria-modal="true"
      aria-label={ariaLabel}
    >
      <div className="modal" style={width ? { width } : undefined}>
        {children}
      </div>
    </div>
  );
}
